import { IconWrapper } from '../runtime';
export default IconWrapper('pic_format_s', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2Z",
      "fill": "#6964FA"
    }
  }), h("path", {
    "attrs": {
      "d": "M2 16C0.895431 16 0 15.1046 0 14L16 14C16 15.1046 15.1046 16 14 16L2 16Z",
      "fill": "#5651E6"
    }
  }), h("path", {
    "attrs": {
      "d": "M8 16L8 14L16 14C16 15.1046 15.1046 16 14 16L8 16Z",
      "fill": "#817CFF"
    }
  }), h("path", {
    "attrs": {
      "d": "M12.0002 3C12.0002 3.55228 11.5525 4 11.0002 4C10.4479 4 10.0002 3.55228 10.0002 3C10.0002 2.44772 10.4479 2 11.0002 2C11.5525 2 12.0002 2.44772 12.0002 3Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "d": "M6.57898 4.50001L8.81956 7.84658L10.3936 5.64314L13.3162 10.4961H11.5652L10.2867 8.37325L8.77959 10.4831L6.59406 7.21874L4.4521 10.4961H2.66016L6.57898 4.50001Z",
      "fill": "white"
    }
  })]);
});